import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ToHttpHeadersService } from '../utils';
import { PaginatedResponse } from '@shared/models';
import { ListActions } from '@shared/enums';
import { LABELS } from '@shared/constants';

@Injectable({
	providedIn: 'root'
})
export class GenericCrudService {

	readonly url = `/api/v1`;
	readonly http = inject(HttpClient);
	readonly toHttpHeaders = inject(ToHttpHeadersService);


  readonly label: Record<string, string> = {
	  ['employee-bank-details']: LABELS.BANK_DETAILS,
		['employee-loan-details']: LABELS.LOAN_DETAILS,
		['employee-loan-interest-details']: LABELS.LOAN_INTERESTS,
		['employee-deduction']: `${LABELS.DEDUCTION}`,
		['employee-addition']: LABELS.ADDITIONS,
		['employee-salary-details']: LABELS.SALARY_DETAILS,
		['payroll-process']: LABELS.PAYROLL_PROCESSING
  };

  /**
   * @param module = e.g. payroll, records, etc.
   * @param subModule = e.g. employee, annual-tax, etc.
   * @param params = filters, tableParams
   * @returns Observable
   */

	list(module: string, subModule: string, params?: Partial<any>): Observable<PaginatedResponse<any>> {
    const endpoint = `${this.url}/${module}/${subModule}`;
		return this.http.get<PaginatedResponse<any>>(endpoint, { params });
	}

	post(module: string, subModule: string, data: any): Observable<any> {
    const endpoint = `${this.url}/${module}/${subModule}`;
		return this.http.post<any>(endpoint, data, this.toHttpHeaders.generateHeaders(ListActions.CREATE, this.label[subModule]));
	}

	put(module: string, subModule: string, data: any): Observable<any> {
    const endpoint = `${this.url}/${module}/${subModule}`;
		return this.http.put<any>(endpoint, data, this.toHttpHeaders.generateHeaders(ListActions.UPDATE, this.label[subModule]));
	}

	delete(module: string, subModule: string, id: number): Observable<any> {
    const endpoint = `${this.url}/${module}/${subModule}`;
		return this.http.delete<any>(`${endpoint}/${id}`, this.toHttpHeaders.generateHeaders(ListActions.DELETE, this.label[subModule]));
	}
}
